import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {inject, Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {ResourceHelper} from '../../helpers/resource-helper';

@Injectable({
  providedIn: 'root'
})
export abstract class Query<T extends { id: number }, H extends Record<string, any>> {
  protected readonly httpService: HttpService;
  protected readonly resource: string;
  protected readonly fromArray: (items: any[]) => T[];

  protected constructor(resource: string, fromArray: (items: any[]) => T[]) {
    this.httpService = inject(HttpService);
    this.resource = resource;
    this.fromArray = fromArray;
  }

  /**
   *
   * @param query
   */
  public load(query: H = {} as H): Observable<T[]> {
    return this.httpService.get<any>({
      url: [this.resource],
      query: ResourceHelper.mapQuery(query)
    }).pipe(map(_items => {
      return this.fromArray(_items);
    }));
  }
}
